import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Classnames from 'classnames';
import CheckBox from '../TabContent/CheckBox.js';
import SavingMessage from '../SavingMessage/SavingMessage';
import './SingleSubscription.css';

// Unsubscribe all subscriptions
class SingleSubscription extends PureComponent {

    static defaultProps = {
        eloquaNames: [],
    };

    renderCheckBoxes(){

        const {
            eloquaNames,
            data,
            params,
        } = this.props;

        // Loop over each group in the eloquaNames
        const allCheckBoxes = eloquaNames.map( (group) => {

            // Render all the checkboxes for this group
            const checkBoxes = group.groupModels.map( (nameToFind, index) => {

                // Find the right subscription
                const subscriptionToLoad = data.contactData.subscriptions.filter(sub => nameToFind === sub.name);
                if (subscriptionToLoad.length > 0) {
                    return (
                        <div 
                            className={Classnames('single-box', index === group.groupModels.length - 1? 'last' : '' )}
                            key={`${group.groupName}${nameToFind}`}
                            >
                            <CheckBox
                                subscription={subscriptionToLoad[0]}
                                indent={false} 
                                key={subscriptionToLoad[0].apiField}
                                showLabel={params.showCheckLabel}
                            />
                        </div>
                    )
                }

                return null

            });       
            
            // Set up the name
            const groupName = group.groupName ? <div className='group-name'>{group.groupName}</div> : null;

            return (

                <div className='single-group' key={group.groupName}>
                    { groupName }
                    { checkBoxes }
                </div>
            )


        });
        
        return allCheckBoxes;
    }

    render() {

        const {
            eloquaNames,
            data,
            params,
        } = this.props;

        // While data is loading return nothing
        if (!data.contactData || !data.contactData.subscriptions || data.contactData.subscriptions.length === 0 || !eloquaNames || eloquaNames.length === 0){
            return null
        }

        return (
            <div className='single-subscription'>

                {/* Show the checkboxes */}
                {this.renderCheckBoxes()}

                {/* Show the saving spinner */}
                <SavingMessage saveInProgress={data.saveInProgress > 0} saveFailed={data.saveFailed} saveColor={params.checkColorOn}/>
            </div>
        )

    }
}

function mapStateToProps(state) {
    return {
        data: state.data,
        params: state.params,
    };
}

export default connect(mapStateToProps, {})(SingleSubscription);
